import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
import classnames from 'classnames';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';
import { Analytics, AnalyticsContext, AnalyticsLocationConsumer, AnalyticsLocationProvider, trackEvent } from 'latitude-analytics';
import { BrowserSupport } from '@latitude/browser-support';
import { Link } from '@latitude/link';
import { BUTTON_STYLE, ANALYTICS, FONT_FAMILY, BREAKPOINT, FONT_WEIGHT, COLOR } from '@latitude/core/utils/constants';
import HamburgerButton from './HamburgerButton';
import HomeButton from './HomeButton';
import LogonButton from './LogonButton';
import TopMenuItem from './TopMenuItem';
import LoginForm from './LoginForm';
import './_header.scss'; // A cutoff point (in pixels to switch to desktop layout)

var DESKTOP_CUTOFF_POINT = 992;

var MicrositeHeader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MicrositeHeader, _React$Component); // HTML element of the top navigation bar
  // HTML element of the hamburger button
  // HTML element of the login button
  // HTML element of the login form


  function MicrositeHeader(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleKeyDown = function (event) {
      // Close the popup on Esc key
      if (event.keyCode === 27) {
        _this.closeActiveMenu();
      }
    };

    _this.handleClick = function (ev) {
      var clickTarget = ev.target; // if we click outside the menu, close it

      if (_this.hamburgerButton && !_this.hamburgerButton.contains(clickTarget) && _this.topMenuItems && !_this.topMenuItems.contains(clickTarget)) {
        _this.closeActiveMenu();
      }

      if (_this.state.isLoginOpen) {
        var _this$loginButtonRef, _this$loginFormRef; // Login Form is open; can we close it?


        if ((_this$loginButtonRef = _this.loginButtonRef) !== null && _this$loginButtonRef !== void 0 && _this$loginButtonRef.current && (_this$loginFormRef = _this.loginFormRef) !== null && _this$loginFormRef !== void 0 && _this$loginFormRef.current) {
          if (!_this.loginButtonRef.current.contains(clickTarget) && !_this.loginFormRef.current.contains(clickTarget)) {
            // Clicked neither the LoginButton nor the LoginForm
            _this.closeLoginForm();
          }
        }
      }
    };

    _this.closeActiveMenu = function () {
      _this.setState({
        isNavOpen: false,
        activeMenuId: null
      });
    };

    _this.handleMenuItemClick = function (menuId) {
      return _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMenuId: state.activeMenuId === menuId ? null : menuId
        });
      });
    };

    _this.toggleNavOpen = function (event, analytics, location) {
      _this.trackNavOpenEvent(_this.state.isNavOpen, analytics, location);

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          isNavOpen: !state.isNavOpen,
          activeMenuId: null,
          isLoginOpen: false
        });
      });
    };

    _this.trackNavOpenEvent = function (isNavOpen, analytics, location) {
      if (!isNavOpen) {
        trackEvent(analytics, {
          category: 'nav',
          action: 'interaction',
          label: 'open',
          location: location
        });
      }
    };

    _this.renderMainMenu = function (isVisible, isMobile) {
      if (isMobile === void 0) {
        isMobile = false;
      }

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this.topMenuItems = el;
        },
        className: classnames('top-menu-items', {
          'is-open': _this.state.isNavOpen,
          'is-visible': isVisible
        }),
        style: isMobile ? {
          position: 'fixed',
          width: '100%',
          left: '-100%'
        } : undefined
      }, _this.props.data.map(function (menuItem) {
        var isActive = _this.state.activeMenuId === menuItem.id;
        return /*#__PURE__*/React.createElement(TopMenuItem, Object.assign({
          key: menuItem.id
        }, menuItem, {
          active: isActive,
          href: menuItem.href,
          onClick: function onClick() {
            _this.handleMenuItemClick(menuItem.id);
          }
        }));
      }));
    };

    _this.closeLoginForm = function () {
      _this.setState({
        isLoginOpen: false
      });
    };

    _this.toggleLoginIsActive = function (location) {
      var newLoginOpen = !_this.state.isLoginOpen;

      _this.setState({
        isLoginOpen: newLoginOpen
      });
    };

    _this.hamburgerButton = /*#__PURE__*/React.createRef();
    _this.topMenuItems = /*#__PURE__*/React.createRef();
    _this.loginButtonRef = /*#__PURE__*/React.createRef();
    _this.loginFormRef = /*#__PURE__*/React.createRef();
    _this.state = {
      isNavOpen: false,
      isNavBackgroundVisible: false,
      activeMenuId: null,
      isLoginOpen: false
    };
    return _this;
  }

  var _proto = MicrositeHeader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
    document.addEventListener('mousedown', this.handleClick, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
    document.removeEventListener('mousedown', this.handleClick, false);
  }
  /*
   * Handle key down
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
      location: ANALYTICS.LOCATION.HEADER
    }, /*#__PURE__*/React.createElement(HeaderContainer, {
      className: classnames('microsite-header', {
        'active-header': this.state.isNavBackgroundVisible,
        'microsite-header--main-nav-minified': this.props.isMinified
      })
    }, /*#__PURE__*/React.createElement(BrowserSupport, null), /*#__PURE__*/React.createElement("div", {
      className: "microsite-header__inner"
    }, /*#__PURE__*/React.createElement(MainBar, {
      className: "microsite-header__nav-wrap no-padding-mob"
    }, /*#__PURE__*/React.createElement("nav", {
      className: "microsite-header__nav",
      itemScope: true,
      itemType: "http://schema.org/SiteNavigationElement"
    }, /*#__PURE__*/React.createElement(HomeButton, {
      mobileVisible: !this.state.isNavOpen
    })), /*#__PURE__*/React.createElement("div", {
      ref: this.loginButtonRef,
      style: {
        margin: '0 0',
        padding: '0 0'
      }
    }, /*#__PURE__*/React.createElement(LogonButton, {
      mobileVisible: true,
      active: this.state.isLoginOpen,
      onClick: function onClick() {
        return _this2.toggleLoginIsActive(location);
      }
    }))), /*#__PURE__*/React.createElement(Shadow, null), /*#__PURE__*/React.createElement(SecondBar, {
      className: "microsite-header__nav-wrap",
      "data-contentful": this.props.contentfulID
    }, /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, function (_ref) {
      var analytics = _ref[0];
      return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, function (location) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HamburgerButton, {
          ref: function ref(el) {
            _this2.hamburgerButton = el;
          },
          hamburgerButtonRef: true,
          navOpen: _this2.state.isNavOpen,
          onClick: function onClick(event) {
            return _this2.toggleNavOpen(event, analytics, location);
          }
        }), /*#__PURE__*/React.createElement(ProductTitle, {
          noStyle: true,
          active: _this2.state.isNavOpen,
          trackId: "nav-home",
          trackEventData: {
            label: _this2.props.microSiteName
          },
          href: "/"
        }, _this2.props.microSiteName, _this2.props.trademark && /*#__PURE__*/React.createElement("sup", null, "\xAE")), /*#__PURE__*/React.createElement(MediaQuery, {
          minWidth: DESKTOP_CUTOFF_POINT
        }, _this2.renderMainMenu(true), /*#__PURE__*/React.createElement(FlexSpacer, null)), /*#__PURE__*/React.createElement(MediaQuery, {
          maxWidth: DESKTOP_CUTOFF_POINT - 1
        }, /*#__PURE__*/React.createElement(FlexSpacer, null)), /*#__PURE__*/React.createElement(CtaButton, {
          button: BUTTON_STYLE.PRIMARY,
          href: _this2.props.ctaHref,
          trackId: "header-apply-now",
          trackEventData: {
            location: location
          }
        }, _this2.props.ctaText || 'Apply Now'));
      });
    })), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: DESKTOP_CUTOFF_POINT - 1
    }, this.renderMainMenu(true, true), /*#__PURE__*/React.createElement("div", {
      className: "top-menu-items__overlay"
    })), /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, function (_ref2) {
      var analytics = _ref2[0];
      return /*#__PURE__*/React.createElement("div", {
        ref: _this2.loginFormRef,
        style: {
          margin: '0 0',
          padding: '0 0'
        }
      }, /*#__PURE__*/React.createElement(LoginForm, {
        analytics: analytics,
        loginForm: _this2.props.loginFormData,
        cardTypes: _this2.props.cardTypesData,
        isOpen: _this2.state.isLoginOpen,
        showLsc: true,
        loginHref: _this2.props.loginHref
      }));
    }))), /*#__PURE__*/React.createElement(HeaderPlaceholder, null));
  };

  return MicrositeHeader;
}(React.Component);

var HeaderContainer = /*#__PURE__*/styled.header.withConfig({
  displayName: "MicrositeHeader__HeaderContainer",
  componentId: "sc-g3e5je-0"
})([""]);
var MainBar = /*#__PURE__*/styled.div.withConfig({
  displayName: "MicrositeHeader__MainBar",
  componentId: "sc-g3e5je-1"
})(["z-index:4;"]);
var Shadow = /*#__PURE__*/styled.div.withConfig({
  displayName: "MicrositeHeader__Shadow",
  componentId: "sc-g3e5je-2"
})(["height:1px;position:relative;z-index:3;box-shadow:0 3px 5px 0 rgba(0,0,0,0.16);"]);
var SecondBar = /*#__PURE__*/styled.div.withConfig({
  displayName: "MicrositeHeader__SecondBar",
  componentId: "sc-g3e5je-3"
})(["&&&{height:48px !important;display:flex;justify-content:space-between !important;background:#fff;box-shadow:0 1px 0 0 rgba(0,0,0,0.05);}.nav-home{display:none;}.top-menu-item{&:last-of-type{display:flex;a{padding-left:30px;}&:before{content:'';height:24px;width:1px;background-color:#b2c7e5;align-self:center;}}}"]);
var ProductTitle = /*#__PURE__*/styled(Link).withConfig({
  displayName: "MicrositeHeader__ProductTitle",
  componentId: "sc-g3e5je-4"
})(["font-family:", ";font-weight:", ";height:100%;line-height:48px;color:", " !important;padding-right:12px;background-color:", ";@media (min-width:1200px){margin-left:15px;}"], FONT_FAMILY.TITLE, FONT_WEIGHT.SEMI_BOLD, COLOR.BLUE_DEEP, function (props) {
  return props.active ? COLOR.BLUE_SKY : 'transparent';
});
var FlexSpacer = /*#__PURE__*/styled.div.withConfig({
  displayName: "MicrositeHeader__FlexSpacer",
  componentId: "sc-g3e5je-5"
})(["flex:1;"]);
var CtaButton = /*#__PURE__*/styled(Link).withConfig({
  displayName: "MicrositeHeader__CtaButton",
  componentId: "sc-g3e5je-6"
})(["height:40px;margin-top:6px;margin-right:12px;padding-left:16px;padding-right:16px;"]);
var HeaderPlaceholder = /*#__PURE__*/styled.div.withConfig({
  displayName: "MicrositeHeader__HeaderPlaceholder",
  componentId: "sc-g3e5je-7"
})(["height:97px;@media (min-width:1200px){height:121px;}@media screen and (min-width:0\0){height:206px;}"]);
export default MicrositeHeader;